import LegalLayout from "@/components/LegalLayout";

export default function CGU() {
  return (
    <LegalLayout title="Conditions Générales d'Utilisation" updated="1er février 2026">
      <div data-testid="cgu-page">
        <p>
          Bienvenue sur <strong>Ma Petite Yole</strong> (ci-après « le Service »). Les présentes
          Conditions Générales d'Utilisation (« CGU ») encadrent l'accès et l'utilisation de
          l'application accessible via l'adresse <a href="https://mapetiteyole.com">mapetiteyole.com</a>.
          En créant un compte ou en utilisant le Service, vous acceptez sans réserve les présentes CGU.
        </p>

        <h2>1. Objet du Service</h2>
        <p>
          Ma Petite Yole est une application de <strong>pronostics amicaux</strong> autour du
          <strong> Tour des Yoles Rondes de Martinique</strong>. Les utilisateurs pronostiquent le
          classement des étapes, prédisent les dessalages et cumulent des <strong>points virtuels</strong>
          au sein de <strong>ligues privées</strong> composées de proches, collègues ou amis.
        </p>
        <p>
          <strong>Le Service ne propose aucun jeu d'argent, aucun pari en numéraire, aucune loterie
          ni aucune activité soumise à l'agrément de l'Autorité Nationale des Jeux (ANJ).</strong>
          Les points affichés (« pts ») sont uniquement virtuels, n'ont aucune valeur monétaire et
          ne peuvent en aucun cas être convertis, échangés, achetés ou revendus.
        </p>

        <h2>2. Inscription et compte</h2>
        <ul>
          <li>L'inscription est <strong>gratuite</strong> et nécessite une adresse email valide.</li>
          <li>Vous devez être <strong>âgé de 15 ans ou plus</strong> et fournir des informations exactes.</li>
          <li>Un compte est strictement personnel. Le partage d'identifiants est interdit.</li>
          <li>
            Vous êtes seul responsable de la confidentialité de votre mot de passe. En cas de perte,
            un administrateur peut le réinitialiser sur demande.
          </li>
          <li>
            Ma Petite Yole se réserve le droit de suspendre ou supprimer tout compte en cas de
            comportement abusif, création de comptes multiples, tentative de triche ou usage
            détourné du Service.
          </li>
        </ul>

        <h2>3. Ligues et pronostics</h2>
        <p>
          Chaque utilisateur peut <strong>créer ou rejoindre une ligue</strong> à l'aide d'un code
          d'invitation ou d'un lien magique. Une ligue regroupe un cercle privé de participants,
          avec son propre classement.
        </p>
        <ul>
          <li>Les pronostics doivent être enregistrés <strong>avant l'heure de départ officielle</strong> de chaque étape (heure de Martinique).</li>
          <li>Une fois l'étape démarrée, les pronostics sont automatiquement verrouillés.</li>
          <li>Les points sont attribués par l'administrateur après la clôture officielle des résultats.</li>
          <li>En cas d'erreur manifeste d'attribution, l'administrateur peut réouvrir ou recalculer une étape.</li>
        </ul>

        <h2>4. Comportement des utilisateurs</h2>
        <p>Il est interdit de :</p>
        <ul>
          <li>Publier des propos injurieux, racistes, discriminatoires ou incitant à la haine.</li>
          <li>Usurper l'identité d'un tiers.</li>
          <li>Utiliser des scripts automatisés, bots ou tout moyen technique visant à fausser le classement.</li>
          <li>Nuire au bon fonctionnement du Service (attaques, spam, exploitation de vulnérabilités).</li>
        </ul>
        <p>
          Tout manquement peut entraîner la suspension immédiate du compte, sans préavis ni
          contrepartie.
        </p>

        <h2>5. Propriété intellectuelle</h2>
        <p>
          La marque « Ma Petite Yole », son logo, sa charte graphique et son code source
          sont la propriété exclusive de Fabien Deris EI. Toute reproduction ou réutilisation
          sans autorisation écrite préalable est strictement interdite.
        </p>
        <p>
          Les photos de yoles téléversées par l'administrateur restent la propriété de leurs
          auteurs respectifs. Les données de suivi en direct proviennent de Georacing et sont
          affichées à titre informatif.
        </p>

        <h2>6. Disponibilité du Service</h2>
        <p>
          Ma Petite Yole est fourni « en l'état ». Nous nous efforçons d'assurer une disponibilité
          continue, mais aucune garantie n'est donnée en cas d'interruption, de maintenance ou de
          panne d'un prestataire tiers (hébergeur, stockage cloud, Georacing, etc.).
        </p>

        <h2>7. Responsabilité</h2>
        <p>
          L'éditeur ne pourra être tenu responsable des dommages indirects (perte de données,
          perte de temps, préjudice moral lié au classement) résultant de l'utilisation du Service.
          Les utilisateurs restent seuls responsables de leur usage.
        </p>

        <h2>8. Modification des CGU</h2>
        <p>
          Les présentes CGU peuvent être mises à jour à tout moment. La date de dernière
          modification est indiquée en haut de la page. En continuant à utiliser le Service après
          une modification, vous acceptez les nouvelles conditions.
        </p>

        <h2>9. Droit applicable</h2>
        <p>
          Les présentes CGU sont régies par le <strong>droit français</strong>. En cas de litige,
          une solution amiable sera recherchée en priorité. À défaut, les tribunaux compétents
          seront ceux du ressort du domicile de l'éditeur.
        </p>

        <h2>10. Contact</h2>
        <p>
          Pour toute question relative aux CGU :{" "}
          <a href="mailto:contact@mapetiteyole.com">contact@mapetiteyole.com</a>.
        </p>
      </div>
    </LegalLayout>
  );
}
